export default __webpack_public_path__ + "static/media/DeleteRed.a2a56639.svg";